import styled from 'styled-components';

export const UserCalendarWrapper = styled.div(props => ({
    padding: "0",
    display: "flex",
    border: "20px",
    flexDirection: "column",
    "& div.notificationDate": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    borderRadius: "0 0 20px 20px",
    ["@media" + props.theme.device.laptopM]: {
        borderRadius: "0",
        boxShadow: "none",

    },
    ...props,
}))